export default "__VITE_ASSET__MiRaKBhN__"